import { FC } from "react";
import { Link } from "react-router-dom";
import InnerPage from "../../shared/components/InnerPage";
import Icon from "../../shared/components/Icon";
import { TRAININGS } from "./trainings";

const EducationsPage: FC = () => (
  <InnerPage
    eyebrow="Gelişim"
    title="Eğitimlerimiz"
    crumbs={[{ label: "Eğitimlerimiz" }]}
    seoDescription="Securitas İtfaiye eğitimleri: yangında davranış şekilleri simülasyonu, teorik ve uygulamalı yangın eğitimi ve ileri seviye ateşli itfaiye eğitimi."
  >
    <div style={{ gridColumn: "1 / -1" }}>
      <div className="it-prose it-prose--wide">
        <h2>Eğitimlerimiz</h2>
      </div>
      <div className="it-tr-cards">
        {TRAININGS.map((training) => (
          <Link className="it-tr" to={training.path} key={training.path}>
            <Icon name={training.icon} className="it-tr-ic" />
            <h4>{training.cardTitle}</h4>
            <span className="it-tr-watch">
              <Icon name="yt" />
              Eğitimi incele
            </span>
          </Link>
        ))}
      </div>
    </div>
  </InnerPage>
);

export default EducationsPage;
